module.exports = __webpack_public_path__ + "img/footer.8cad91fc.png";